import { render, staticRenderFns } from "./UserRol.vue?vue&type=template&id=ef864168&scoped=true"
import script from "./UserRol.vue?vue&type=script&lang=js"
export * from "./UserRol.vue?vue&type=script&lang=js"
import style0 from "./UserRol.vue?vue&type=style&index=0&id=ef864168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef864168",
  null
  
)

export default component.exports